export default __webpack_public_path__ + "static/location-bd350b5e8376c5fc4719fe91ae27cf30.png";